var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgApprovedShield = function SvgApprovedShield(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9.21003L7.66667 12.1109C7.74423 12.2264 7.84822 12.3217 7.97002 12.389C8.09182 12.4563 8.22791 12.4936 8.36699 12.4977C8.50608 12.5019 8.64415 12.4728 8.76975 12.4129C8.89534 12.353 9.00485 12.264 9.08917 12.1534L15.625 3.88086",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.625C2.16848 0.625 1.85054 0.756696 1.61612 0.991116C1.3817 1.22554 1.25 1.54348 1.25 1.875V9.375C1.25 13.3858 7.27833 17.8492 9.3275 19.175C9.52752 19.3055 9.76118 19.375 10 19.375C10.2388 19.375 10.4725 19.3055 10.6725 19.175C12.7217 17.8492 18.75 13.3858 18.75 9.375V1.875C18.75 1.71085 18.7177 1.5483 18.6548 1.39665C18.592 1.24499 18.5 1.10719 18.3839 0.991116C18.2678 0.875043 18.13 0.782969 17.9784 0.720151C17.8267 0.657332 17.6642 0.625 17.5 0.625H2.5Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApprovedShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "approvedShield.560c44fa02d1384d43130801b4b263c7.svg";